"use strict";
(globalThis["webpackChunktvg_shopify_theme"] = globalThis["webpackChunktvg_shopify_theme"] || []).push([[9889],{

/***/ 2211:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* unused harmony export GlobalCartController */
/* harmony import */ var _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7809);


class GlobalCartController extends _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__.Controller {
  static outlets = ['sidecart', 'mini-stepper']
  static targets = [
    'itemCount',
    'feedbackContainer',
    'flashMessageTemplate',
  ]
  static values = {
    itemCount: Number,
    visibility: String,
    sidecartOpen: Boolean,
    hideStepper: {
      type: Boolean,
      default: false,
    },
  }

  connect() {
    this.lastScrollY = window.scrollY
    this.scrollThreshold = 50 // minimum scroll distance before hiding/showing
    this.handleScroll = this.handleScroll.bind(this)
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    const currentScrollY = window.scrollY
    const scrollDifference = Math.abs(currentScrollY - this.lastScrollY)

    // Only act if we've scrolled enough to avoid jittery behavior
    if (scrollDifference < this.scrollThreshold) return

    const scrollingDown = currentScrollY > this.lastScrollY
    this.lastScrollY = currentScrollY

    this.computeVisibility(scrollingDown)
  }

  openCart() {
    this.sidecartOutlet.open("GlobalCart")
  }

  itemCountValueChanged() {
    this.computeVisibility()
    this.itemCountTarget.innerText = this.itemCountValue
  }

  shouldShowStepper() {
    return (
      this.itemCountValue > 0 &&
      this.hasMiniStepperOutlet &&
      this.miniStepperOutlet.stepsValue.length > 0 &&
      !this.hideStepperValue
    )
  }

  sidecartOpenValueChanged() {
    this.computeVisibility()
  }

  computeVisibility(scrollingDown = false) {
    if (this.sidecartOpenValue) {
      this.visibilityValue = 'none'
      return
    }

    if (this.shouldShowStepper()) {
      // If we meet at least one step of the stepper, show both button and stepper
      if (scrollingDown) {
        this.visibilityValue = 'half'
      } else {
        this.visibilityValue = 'full'
      }
    } else if (this.itemCountValue >= 1) {
      // If there's at least 1 item, always show the cart button
      this.visibilityValue = 'half'
    } else if (this.itemCountValue == 0) {
      // If no items are in cart, hide the global cart
      this.visibilityValue = 'none'
    }
  }

  onSidecartUpdated(event) {
    const detail = event.detail

    this.itemCountValue = detail.totalQuantity
    this.sidecartOpenValue = detail.open
    this.hideStepperValue = detail.hasSmallBundleItem
  }
}

Stimulus.register("global-cart", GlobalCartController)


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(2211)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);